import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowDown } from 'lucide-react';
export function ProductRevealSection() {
  const includes = ['The Main Happy Lunchbox Guide (+200 Recipes)', '15-Minute Magic: Real food for busy lives.', 'Simple Ingredients: Everything found at your local grocery store.', 'Weekly Meal Plans: Never ask "What should I cook?" again.', 'The Balanced Structure: Learn exactly what to include to avoid energy crashes.'];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-138">
      <div className="max-w-4xl mx-auto text-center" data-id="element-139">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] mb-12 uppercase" data-id="element-140">
          What you get today with the Happy Lunchbox System:
        </h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-lg mx-auto mb-12" data-id="element-141">
          {/* Product mockup */}
          <img src="https://cdn.magicpatterns.com/uploads/qrDdbpi9jE91QhBbvnXd59/a18af6d0-54bf-49e1-9524-ff10e11e9621.webp" alt="Happy Lunchbox System 6-in-1 boxset with 5 bonuses included" className="w-full h-auto drop-shadow-2xl" loading="lazy" decoding="async" data-id="element-142" />
        </motion.div>

        <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 text-left max-w-2xl mx-auto mb-12" data-id="element-143">
          <div className="text-center mb-6" data-id="element-144">
            <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-2" data-id="element-145">
              INCLUDES
            </span>
            <h3 className="text-2xl font-bold text-[#1f2e10]" data-id="element-146">
              Our Flagship Digital Manual
            </h3>
          </div>
          <ul className="space-y-4" data-id="element-147">
            {includes.map((item, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="flex items-start gap-3" data-id="element-148">
                <div className="mt-1 bg-green-100 rounded-full p-1 flex-shrink-0" data-id="element-149">
                  <Check size={16} className="text-green-600" data-id="element-150" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-151">{item}</span>
              </motion.li>)}
          </ul>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-152">
          <p className="text-xl font-bold text-[#1f2e10]" data-id="element-153">And much more...</p>
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5
        }} data-id="element-154">
            <ArrowDown size={32} className="text-red-500" data-id="element-155" />
          </motion.div>
        </div>
      </div>
    </section>;
}